import React from 'react';
import {
  ItemComment
} from './sub-view/need-offer';
import {Textarea} from 'components/vitrade-forms/common';
import {Link} from 'react-router-dom';

class NeedOfferDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataComment: [
        {id: 1}
      ]
    };
  }

  render() {
    return (
      <section className='need-offer-container mb35'>
        <h2 className='need-offer-title'>Chi tiết nhu cầu</h2>
        <DetailNeedOffer/>
        <div className='need-offer-list-comment-container'>
          <div className='need-offer-business-detail-wrap'>
            <Link to={`/my-business/demand/${this.props.params.id}`} className='need-offer-back-to-list'><i className='fa fa-arrow-circle-o-left'/>Trở lại danh sách</Link>
            <BusinessDetail params={this.props.params}/>
          </div>
          <div className='need-offer-list-comment'>
            {
              this.state.dataComment.map((item, i) => {
                return (
                  <ItemComment key={i} {...item}/>
                );
              })
            }
          </div>
          <form className='need-offer-post-comment-form'>
            <Textarea type="text" className='need-offer-post-comment-input mb15' placeholder="Nhập phản hồi..."/>
            <button type='submit' className='need-offer-post-comment-btn'>Phản hồi</button>
          </form>
        </div>
      </section>
    );
  }
}

export default NeedOfferDetail;



// WEBPACK FOOTER //
// ./components/my-business/NeedOfferDetail.jsx